import React, { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { AssetImage } from './image'
import { pageMaxWidth } from '../styles/page-max-width'
import { boxCopyText, boxMainText } from '../styles/text-styles'

const Outer = styled.div`
  ${pageMaxWidth}
  @media (max-width: 60rem){
    
  }
`

const Inner = styled.div`

@media (max-width: 60rem){
  
}
`

const Item = styled.div`
  display: grid;
  gap: 3.625rem;
  @media (max-width: 60rem){
    gap: 0;
  }
  &:nth-child(odd) {
    grid-template-columns: 4fr 6fr;
    @media (max-width: 60rem){
      grid-template-columns: 1fr;
    }
  }
  &:nth-child(even) {
    grid-template-columns: 6fr 4fr;
    @media (max-width: 60rem){
      grid-template-columns: 1fr;
    }
  }
  & + & {
    margin-top: 8rem;
    @media (max-width: 60rem){
      margin-top: 8rem;
    }
  }
`

const ContentsContainer = styled.div`
  margin-top: 5rem;
  @media (max-width: 60rem){
    margin-top: 3rem;
  }
`

const Head = styled.div`
${boxCopyText}
@media (max-width: 60rem){
  
}
`

const Text = styled.div`
${boxMainText}
margin-top: 1.75rem;
@media (max-width: 60rem){
  margin-top: 1.5rem;
}

small {
  font-size: 0.7em;
  display: block;
}
`

const ImageContainer = styled.div`
  ${Item}:nth-child(odd) & {
    order: 1;
    margin-right: calc(var(--side-margin) * -1);
    @media (max-width: 60rem){
      order: -1;
    }
  }
  ${Item}:nth-child(even) & {
    order: -1;
    margin-left: calc(var(--side-margin) * -1);
    @media (max-width: 60rem){
      
    }
  }
`

type SwingSectionsProps = {
  articles: {
    image: ReactNode,
    head: ReactNode,
    text: ReactNode
  }[]
}
export const SwingSections: FunctionComponent<SwingSectionsProps> = ({articles}) => {
  return <Outer>
    <Inner>
      {
        articles.map(article => {
          return <Item>
            <ImageContainer>
              {article.image}
            </ImageContainer>
            <ContentsContainer>
              <Head>
                {article.head}
              </Head>
              <Text>
                {article.text}
              </Text>
            </ContentsContainer>
          </Item>
        })
      }
    </Inner>
  </Outer>
}